import React from "react";
import { Switch, Route, BrowserRouter } from "react-router-dom";
import Analytics from "react-router-ga";
import { connect } from "react-redux";

// import withBreadcrumbs from "react-router-breadcrumbs-hoc";

import SideMenu from "../components/sideMenu/sideMenu";
import Root from "../container/root";
import LoginForm from "../components/Login/loginForm";
import Logout from "../components/Login/logout";
import DashboardContainer from "../components/dashboard/dashboardContainer";
// import DashboardAffiliateContainer from "../components/affiliateComponents/dashboardAffiliate/dashboardAffiliateContainer";
import SubuserAffiliateContainer from "../components/affiliateComponents/subuserAffiliate/subuserAffiliateContainer";
import SubuserListAffiliateContainer from "../components/affiliateComponents/subuserAffiliate/subuserListAffiliateContainer";
import SubuserUpdateAffiliateContainer from "../components/affiliateComponents/subuserAffiliate/subuserUpdateAffiliateContainer";
import SubuserUpdateBusinessContainer from "../components/affiliateComponents/subuserBusiness/subuserUpdateBusinessContainer";
import EnrollmentPage from "../components/affiliateComponents/enrollment/enrollmentListContainer";
import AffiliateLog from "../components/activity/activityLog";
// import myReferralsPage from "../components/affiliateComponents/myReferrals/referralsDashboardContainer";
import ViewSettlement from "../components/affiliateComponents/settlementDashboard/viewSettlement";
import ViewsReferrals from "../components/affiliateComponents/myReferrals/viewSettlement";
import SubuserBusinessContainer from "../components/affiliateComponents/subuserBusiness/subuserBusinessContainer";
import SubuserListBusinessContainer from "../components/affiliateComponents/subuserBusiness/subuserListBusinessContainer";
import requireAuth from "../utils/requireAuth";
import Signup from "../components/signup/signup";
import SignupPartner from "../components/partner/signup";
import partnerDashboard from "../components/partnerdashboard/partnerDashboardContainer";
import parentPartnerDashboard from "../components/partnerdashboard/parentPartnerDashboardContainer";
import SettlementDashboardContainer from "../components/partnerdashboard/settlementDashboardContainer";
import SettlementDetailContainer from "../components/partnerdashboard/settlementDetailContainer";
import SettlementDetailContainerByGroup from "../components/partnerdashboard/settlementDetailContainerByGroup";
import DashboardSettlementDetails from "../components/partnerdashboard/dashboardSettlementDetails";
import dashboardSettlementDetailsByGroups from "../components/partnerdashboard/dashboardSettlementDetailsByGroups";
import DashboardEnrollmentList from "../components/partnerdashboard/settlementEnrollment"
import DashboardEnrollmentListByGroups from "../components/partnerdashboard/settlementEnrollmentByGroups"
// import SettlementDashboardContainerDetail from "../components/partnerdashboard/partnerDashboardContainer";

import UserDashboardContainer from "../components/partnerdashboard/userDashboardContainer";
import GroupDashboardContainer from "../components/partnerdashboard/GroupDashboardContainer";

import RegistrationContainer from "../components/partnerdashboard/RegistrationContainer"
import UserDetailContainer from "../components/partnerdashboard/userDetailContainer";
import GroupDetailContainer from "../components/partnerdashboard/GroupDetailContainer";

// import RegistrationLinks from "../components/affiliateComponents/registrationLinks/registrationLinks";

import ForgotPassword from "../components/ForgotPassword/forgotPassword";
import ForgotPasswordAffiliate from "../components/ForgotPassword/forgotPasswordAffiliate";
import requireLoginAuth from "../utils/requireLoginAuth";
import SettlementListContainer from "../components/settlementDashboard/settlementListContainer";
import EnrollmentListContainer from "../components/settlementEnrollment/enrollmentListContainer";
import VerifyCode from "../components/VerifyCode/verifyCode";
import landingPageContainer from "../components/affiliateComponents/landingPage/landingPageContainer";
import Profile from "../components/profile/userPorfile";

import ProfilePartner from "../components/profile/userPorfilePartner"
import Faq from "../components/faq/faq";
import Privacy from "../components/pages/privacy";
import RevocableLetter from "../components/pages/revocableLetter";
import SignatureConsent from "../components/pages/signatureConsent";
import TermsAndCondition from "../components/pages/termsAndCondition";
import UserAgreement from "../components/pages/userAgreement";
import ResetPasswordMobile from "../components/pages/resetPasswordMobile";
import ChangePlan from "../components/plan/changePlan";
// import ApplyContainerQuestion from "../components/applyQuestion/applyContainerQuestion";
import ApplySettlement from "../components/applySettlement/applyContainerQuestion";
import ApplySettlementDocument from "../components/applySettlement/applyContainerDocument";
// import Documents from '../components/common/documentsView';
// import ApplyContainerQuestionForNeedAttention from '../components/applyQuestionNeedAttention/applyContainerQuestion';
import RegistrationLinkContainer from "../components/affiliateComponents/registrationLinks/registrationLinkContainer";
import Notifications from "../components/notification";
import Transactions from "../components/transactions";

import AffiliatePage from "../components/common/affiliatePage";
import ProfileTermsPage from "../components/common/profile-terms";
// import CreatePaymentMethod from "../components/payments/createPaymentMethod";
import signupStep1 from "../components/signup/signupStep1";
import termsAndConditionPage from "../components/signup/termsAndConditionPage";
import signUpPlanPage from "../components/signup/signUpPlanPage";
import signUpSignaturePage from "../components/signup/signUpSignaturePage";
import ServiceAgreement from "../components/pages/ServiceAgreement";
import PartnerHeader from "../components/common/partnerHeader";
import PartnerTopMenu from "../components/common/partnerTopMenu";
import GroupListDashboardContainer from "../components/partnerdashboard/GroupListDashboardContainer";
import GroupListPartnerDashboardContainer from "../components/partnerdashboard/GroupListPartnerDashboardContainer"

// const Breadcrumbs = withBreadcrumbs()(({ breadcrumbs }) => (
//   <React.Fragment>
//     {breadcrumbs.map(({ breadcrumb }) => (breadcrumb.key !== "/" && <div>{console.log('breadcrumb', breadcrumb)}<Link to={breadcrumb.key}>{breadcrumb}</Link></div>))}
//   </React.Fragment>
// ));

class Routes extends React.Component {
  // constructor(props) {
  //   super(props);
  //   // var showNavi = true;
  //   this.state = {
  //     showNavi: true
  //   };
  // }

  render() {
    // const { userInfo } = this.props;
    // const AuthInfo = localStorage.getItem('user');
    const roleName = localStorage.getItem('roleName');
    return (
      <div>
        <Root>
          <BrowserRouter>
            <Analytics id="UA-143098160-1" debug>

              {/* <BrowserRouter basename='/collectively'> */}
              {(roleName !== "Affiliate" && roleName !== 'Affiliate-SubUser') ? (

                <span className="test">
                  <SideMenu username="a" />
                  <Switch>
                    <Route
                      exact
                      path="/logout"
                      component={Logout}
                    />
                    <Route
                      exact
                      path="/"
                      component={requireLoginAuth(LoginForm)}
                    />
                    <Route
                      path="/signup/:affiliateId/:partnerType/:emailId"
                      exact
                      component={Signup}
                    />
                    {/* <Route
                    path="/dasbordp"
                    exact
                    component={partnerDashboard}
                  /> */}
                    <Route
                      path="/signup/:affiliateKey/:emailId"
                      exact
                      component={Signup}
                    />
                    <Route path="/signupPartner" exact component={Signup} />
                    <Route
                      path="/profile-terms"
                      exact
                      component={requireAuth(ProfileTermsPage)}
                    />
                    <Route
                      path="/signup/:affiliateKey"
                      exact
                      component={SignupPartner}
                    />
                    <Route
                      path="/signup"
                      exact
                      component={SignupPartner}
                    />

                    {/* <Route
                      path="/signup"
                      exact
                      component={requireLoginAuth(SignupPartner)}
                    /> */}

                    <Route
                      path="/signup-disabled"
                      exact
                      component={requireLoginAuth(AffiliatePage)}
                    />
                    <Route
                      path="/session-expired"
                      exact
                      component={requireLoginAuth(AffiliatePage)}
                    />

                    <Route path="/verify-code" exact component={VerifyCode} />
                    <Route
                      path="/reset-password"
                      exact
                      component={ForgotPassword}
                    />
                    <Route
                      path="/change-password"
                      exact
                      component={ForgotPasswordAffiliate}
                    />
                    <Route
                      path="/activity-log"
                      exact
                      component={AffiliateLog}
                    />
                    <Route
                      path="/dashboard"
                      exact
                      component={requireAuth(DashboardContainer)}
                    // component={requireAuth(() => <DashboardContainer enableNav={this.enableNavigation} />)}
                    />

                    <Route
                      path="/addSubUsers"
                      exact
                      component={requireAuth(SubuserAffiliateContainer)}
                    />
                    <Route
                      path="/addSubUsersBusiness"
                      exact
                      component={requireAuth(SubuserBusinessContainer)}
                    />
                    <Route
                      path="/manageSubUsers"
                      exact
                      component={requireAuth(SubuserListAffiliateContainer)}
                    />
                    <Route
                      path="/manageSubUsersBusiness"
                      exact
                      component={requireAuth(SubuserListBusinessContainer)}
                    />
                    <Route
                      path="/profile/update/:subuserId"
                      exact
                      component={SubuserUpdateAffiliateContainer}
                    />
                    <Route
                      path="/businessSubUser/update/:subuserId"
                      exact
                      component={SubuserUpdateBusinessContainer}
                    />
                    {/* <Route
                    path="/myReferrals"
                    exact
                    component={myReferralsPage}
                  /> */}
                    <Route
                      path="/enrollmentpage"
                      exact
                      component={EnrollmentPage}
                    />
                    <Route
                      path="/enrollmentpage/:settlementId"
                      exact
                      component={EnrollmentPage}
                    />
                    <Route
                      path="/view/:settlementId"
                      exact
                      component={ViewSettlement}
                    />
                    <Route
                      path="/viewReferrals/:referralId/:roleName"
                      exact
                      component={ViewsReferrals}
                    />

                    <Route
                      path="/settlement"
                      exact
                      component={requireAuth(SettlementListContainer)}
                    />
                    {/* <Route
                    path="/SettlementAffiliate"
                    exact
                    component={requireAuth(
                      SettlementDashboardContainerAffiliate
                    )}
                  /> */}
                    <Route
                      path="/apply/:eid"
                      exact
                      component={requireAuth(ApplySettlement)}
                    />
                    <Route
                      path="/apply/:review/:eid"
                      exact
                      component={requireAuth(ApplySettlement)}
                    />
                    {/* <Route
                  path="/apply/:review/documents/:eid"
                  exact
                  component={requireAuth(Documents)}
                /> */}

                    <Route
                      path="/apply-document/:eid"
                      exact
                      component={requireAuth(ApplySettlementDocument)}
                    />

                    {/* <Route
              path="/apply-need-attention/:eid"
              exact
              component={requireAuth(ApplyContainerQuestionForNeedAttention)}
            /> */}
                    <Route
                      path="/enrollment"
                      exact
                      component={requireAuth(EnrollmentListContainer)}
                    />
                    <Route
                      path="/partner-pages/"
                      exact
                      component={RegistrationLinkContainer}
                    />
                    <Route
                      path="/landing/:affiliateId/:partnerType"
                      exact
                      component={landingPageContainer}
                    />
                    <Route
                      path="/profile"
                      exact
                      component={requireAuth(Profile)}
                    />
                    <Route path="/faq" exact component={requireAuth(Faq)} />
                    <Route path="/privacy-policy" exact component={Privacy} />
                    <Route
                      path="/revocable-letter-of-agency"
                      exact
                      component={RevocableLetter}
                    />
                    <Route
                      path="/e-signature-consent"
                      exact
                      component={SignatureConsent}
                    />
                    <Route
                      path="/terms-and-condition"
                      exact
                      component={TermsAndCondition}
                    />
                    <Route
                      path="/user-agreement"
                      exact
                      component={UserAgreement}
                    />

                    <Route
                      path="/service-agreement/:siteId/:siteKey"
                      exact
                      component={requireAuth(ServiceAgreement)}
                    />

                    <Route
                      path="/reset-password-mobile"
                      exact
                      component={ResetPasswordMobile}
                    />
                    <Route
                      path="/notifications"
                      exact
                      component={requireAuth(Notifications)}
                    />
                    <Route
                      path="/transaction"
                      exact
                      component={requireAuth(Transactions)}
                    />
                     
                    <Route
                      path="/change-plan"
                      exact
                      component={requireAuth(ChangePlan)}

                    // component={() => <ChangePlan disableNav={this.handleNavigation} />}
                    />
                    <Route
                      path="/add-payment-method"
                      exact
                      component={requireAuth(ProfileTermsPage)}
                    // component={requireAuth(() => <CreatePaymentMethod disableNav={this.handleNavigation} />)}
                    />
                    <Route
                      path="/signup-step1"
                      exact
                      component={requireLoginAuth(signupStep1)}
                    />
                    <Route
                      path="/signup-terms-condition"
                      exact
                      component={requireLoginAuth(termsAndConditionPage)}
                    />
                    <Route
                      path="/signup-plan-page"
                      exact
                      component={requireLoginAuth(signUpPlanPage)}
                    />
                    <Route
                      path="/signup-signature-page"
                      exact
                      component={requireLoginAuth(signUpSignaturePage)}
                    />
                  </Switch>
                </span>


              ) : (

                  <div
                    className={`${
                      roleName === "Affiliate" || roleName === 'Affiliate-SubUser'
                        ? "p-wrapper groupDetailView"
                        : ""
                      }`}
                  >
                    <div className="">
                      <div
                        className={`${
                          roleName === "Affiliate" || roleName === 'Affiliate-SubUser'
                            ? "main-content "
                            : ""
                          }`}
                      >
                        {(roleName === "Affiliate" || roleName === 'Affiliate-SubUser') && (
                          <PartnerHeader />
                        )}

                        <div
                          className={`${
                            roleName === "Affiliate" || roleName === 'Affiliate-SubUser'
                              ? "container p-container tab-pad-none"
                              : ""
                            }`}
                        >
                          {(roleName === "Affiliate" || roleName === 'Affiliate-SubUser') && (
                            <PartnerTopMenu />
                          )}

                          <Switch>
                            <Route
                              exact
                              path="/logout"
                              component={Logout}
                            />
                            <Route
                              exact
                              path="/"
                              component={requireLoginAuth(LoginForm)}
                            />
                            <Route
                              path="/revocable-letter-of-agency"
                              exact
                              component={RevocableLetter}
                            />
                            <Route
                              path="/e-signature-consent"
                              exact
                              component={SignatureConsent}
                            />
                            <Route
                              path="/terms-and-condition"
                              exact
                              component={TermsAndCondition}
                            />
                            <Route
                              path="/user-agreement"
                              exact
                              component={UserAgreement}
                            />

                            <Route
                              path="/service-agreement/:siteId/:siteKey"
                              exact
                              component={requireAuth(ServiceAgreement)}
                            />
                            <Route
                              path="/signup/:affiliateId/:partnerType/:emailId"
                              exact
                              component={Signup}
                            />
                            <Route
                              path="/change-password"
                              exact
                              component={ForgotPasswordAffiliate}
                            />

                            <Route
                              path="/signup/:affiliateKey/:emailId"
                              exact
                              component={Signup}
                            />
                            <Route
                              path="/signupPartner"
                              exact
                              component={Signup}
                            />

                            <Route
                              path="/change-plan"
                              exact
                              component={requireAuth(ChangePlan)}

                            // component={() => <ChangePlan disableNav={this.handleNavigation} />}
                            />
                            <Route
                              path="/add-payment-method"
                              exact
                              component={requireAuth(ProfileTermsPage)}
                            // component={requireAuth(() => <CreatePaymentMethod disableNav={this.handleNavigation} />)}
                            />
                            <Route
                              path="/signup-step1"
                              exact
                              component={requireLoginAuth(signupStep1)}
                            />
                            <Route
                              path="/signup-terms-condition"
                              exact
                              component={requireLoginAuth(termsAndConditionPage)}
                            />
                            <Route
                              path="/signup-plan-page"
                              exact
                              component={requireLoginAuth(signUpPlanPage)}
                            />
                            <Route
                              path="/signup-signature-page"
                              exact
                              component={requireLoginAuth(signUpSignaturePage)}
                            />

                            <Route
                              path="/profile-terms"
                              exact
                              component={requireAuth(ProfileTermsPage)}
                            />
                            <Route
                              path="/signup/:affiliateKey"
                              exact
                              component={SignupPartner}
                            />
                            <Route
                              path="/signup"
                              exact
                              component={SignupPartner}
                            />
                            <Route
                              path="/dashboard"
                              exact
                              component={requireAuth(DashboardContainer)}
                            // component={requireAuth(() => <DashboardContainer enableNav={this.enableNavigation} />)}
                            />

                            <Route
                              path="/signup"
                              exact
                              component={SignupPartner}
                            />

                            <Route
                              path="/signup-disabled"
                              exact
                              component={requireLoginAuth(AffiliatePage)}
                            />
                            <Route
                              path="/session-expired"
                              exact
                              component={requireLoginAuth(AffiliatePage)}
                            />

                            <Route
                              path="/verify-code"
                              exact
                              component={VerifyCode}
                            />
                            <Route
                              path="/reset-password"
                              exact
                              component={ForgotPassword}
                            />
                              <Route
                                path="/profile"
                                exact
                                component={requireAuth(ProfilePartner)}
                              />

                            <Route
                              path="/profile/addSubUsers"
                              exact
                              component={requireAuth(SubuserAffiliateContainer)}
                            />
                          <Route
                              path="/profile/update/:subuserId"
                              exact
                              component={SubuserUpdateAffiliateContainer}
                            />


                            <Route
                              path="/affiliate"
                              exact
                              component={requireAuth(partnerDashboard)}
                            />

                            <Route
                              path="/parent-affiliate"
                              exact
                              component={requireAuth(parentPartnerDashboard)}
                            />

                            <Route
                              path="/settlementAffiliate"
                              exact
                              component={requireAuth(
                                SettlementDashboardContainer
                              )}
                            />

                            <Route
                              path="/settlementAffiliate/:id"
                              exact
                              component={requireAuth(SettlementDetailContainer)}
                            />

                            <Route
                              path="/userDetail/:id/:roleName"
                              exact
                              component={requireAuth(UserDetailContainer)}
                            />

                            <Route
                              path="/groupDetail/:groupId/:partnerId/:userId"
                              exact
                              component={requireAuth(GroupDetailContainer)}
                            />

                            <Route
                              path="/groupDetail/:groupId/:parentPartnerId"
                              exact
                              component={requireAuth(GroupListPartnerDashboardContainer)}
                            />

                            <Route
                              path="/usersAffiliate"
                              exact
                              component={requireAuth(UserDashboardContainer)}
                            />

                            <Route
                              path="/groupsAffiliate"
                              exact
                              component={requireAuth(GroupDashboardContainer)}
                            />

                              <Route
                              path="/groupsAffiliate/:id"
                              exact
                              component={requireAuth(GroupListDashboardContainer)}
                            />


                            <Route
                              path="/resources"
                              exact
                              component={requireAuth(RegistrationContainer)}
                            />

                            <Route
                              path="/settlementAffiliate/settlement-details/:id"
                              exact
                              component={requireAuth(DashboardSettlementDetails)}
                            />

                            <Route
                              path="/settlementAffiliate/settlement-details/:id/:groupId/:partnerId"
                              exact
                              component={requireAuth(dashboardSettlementDetailsByGroups)}
                            />

                            <Route
                              path="/settlementAffiliate/enrollment-list/:id"
                              exact
                              component={requireAuth(DashboardEnrollmentList)}
                            />

                            <Route
                              path="/settlementAffiliate/enrollment-list/:id/:groupId/:partnerId"
                              exact
                              component={requireAuth(DashboardEnrollmentListByGroups)}
                            />

                            <Route
                              path="/settlementAffiliate/:id/:groupId/:partnerId"
                              exact
                              component={requireAuth(SettlementDetailContainerByGroup)}
                            />
                          </Switch>
                        </div>
                      </div>
                    </div>
                  </div>

                )}
            </Analytics>
          </BrowserRouter>
        </Root>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  userInfo: state.data.userInfo
});
export default connect(mapStateToProps)(Routes);

// export default Routes;
